<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";
	import { demoData } from "./data";
	import Edit from "./Edit.svelte";

	var data = {
		nodes: null,
		edges: null
	};

	var network = null;

	let shown = false;

	let dispatch = createEventDispatcher();

	export function show() {
		shown = !shown;
		dispatch("show", shown);
	}

	onMount(async () => {
		function makeid(length) {
			var result = "";
			var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
			var charactersLength = characters.length;
			for (var i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		}

		function chunk(str, n) {
			var ret = [];
			var i;
			var len;

			for (i = 0, len = str.length; i < len; i += n) {
				ret.push(str.substr(i, n));
			}

			return ret;
		}

		const data2 = demoData;

		let nextId = 1;

		data = {
			nodes: new window.vis.DataSet(data2.nodes),
			edges: new window.vis.DataSet(data2.edges)
		};

		data.nodes.on("*", function (event, properties, senderId) {
			console.log("Nodes changed");
			//setTimeout(getExport, 0);
		});

		data.edges.on("*", function (event, properties, senderId) {
			console.log("edges changed");
			//setTimeout(getExport, 0);
		});

		// create a network
		var container = document.getElementById("mynetwork");

		// var options = { physics: { enabled: true, wind: { x: 1, y: 0 } } };
		var options = {
			layout: { randomSeed: 100 },
			interaction: { navigationButtons: true, keyboard: true },
			manipulation: {
				addEdge: function (data, callback) {
					if (data.from == data.to) {
						var r = confirm("Do you want to connect the node to itself?");
						if (r == true) {
							callback(data);
						}
					} else {
						callback(data);
					}
				}
			},
			edges: {
				font: {
					size: 12
				}
			},
			nodes: {
				shape: "box",
				margin: 10,
				font: {
					multi: "html"
				}
			},
			physics: {
				// Even though it's disabled the options still apply to network.stabilize().
				enabled: true,
				solver: "repulsion",
				repulsion: {
					nodeDistance: 400 // Put more distance between the nodes.
				}
			}
		};
		network = new window.vis.Network(container, data, options);

		network.once("stabilizationIterationsDone", function () {
			network.focus(1, { scale: 1 });
			show();
		});

		// for (let i = 1; i < 1000; i++) {
		// 	const random = Math.floor(Math.random() * (nextId - 1) + 1);
		// 	const random2 = Math.floor(Math.random() * (nextId - 1) + 1);
		// 	data.nodes.add([
		// 		{
		// 			id: nextId,
		// 			font: { multi: true },
		// 			title: `Node ${nextId}`,
		// 			label: `${chunk(makeid(random2), 20).join("\n")}`,
		// 			group: nextId.toString().charAt(0)
		// 		}
		// 	]);
		// 	data.edges.add([{ from: random, to: nextId }]);
		// 	nextId++;
		// }
		// var myTimeout = setInterval(() => {
		// 	const random = Math.floor(Math.random() * (nextId - 1) + 1);
		// 	const random2 = Math.floor(Math.random() * 255);
		// 	data.nodes.add([
		// 		{
		// 			id: nextId,
		// 			font: { multi: true },
		// 			title: `Node ${nextId}`,
		// 			label: `${chunk(makeid(random2), 20).join("\n")}`,
		// 			group: nextId.toString().charAt(0)
		// 		}
		// 	]);
		// 	data.edges.add([{ from: random, to: nextId }]);
		// 	if (nextId === 100) {
		// 		clearInterval(myTimeout);
		// 	}
		// 	nextId++;
		// }, 1);

		// setTimeout(() => {
		// 	console.log(network.storePositions());
		// }, 10000);
	});

	function getExport() {
		var out_data = {
			nodes: data.nodes.get(),
			edges: data.edges.get()
		};

		// Optional: retrieve node positioning data and add to output
		var positions = network.getPositions();
		out_data.nodes.forEach(function (item, index, array) {
			var pos = positions[item.id];
			if (pos !== undefined) {
				array[index].x = pos.x;
				array[index].y = pos.y;
			}
		});

		console.log(JSON.stringify(out_data));
		navigator.clipboard.writeText(JSON.stringify(out_data));
		// Save your data to file here
	}
</script>

<main>
	<div id="mynetwork" />
	<button on:click={getExport}>Export</button>
	<button class="button2" on:click={show}>Toggle Editor</button>
	{#if shown}
		<Edit {data} {network} />
	{/if}
</main>

<style>
	#mynetwork {
		width: 100vw;
		height: 100vh;
		background-color: #333333;
	}

	button {
		position: absolute;
		top: 45px;
		left: 20px;
		border: 1px solid aqua;
		padding: 12px;
		border-radius: 23px;
	}
	.button2 {
		position: absolute;
		top: 95px;
		left: 20px;
		border: 1px solid aqua;
		padding: 12px;
		border-radius: 23px;
	}
</style>
